import { config } from '@/config';

type TLanguageMapType = {
    [key: string]: {
        name: string
        display: string;
        code: string;
        href: string;
        flagCode?: string;
        separateDomain?: boolean;
    };
};

export const LanguageMap: TLanguageMapType = {
    en: { name: 'English', display: 'EN', code: 'en', href: '/en', flagCode: 'GB' },
    es: { name: 'Español | Spanish', display: 'ES', code: 'es', href: '/es' },
    ja: { name: '日本語 | Japanese', display: 'JP', code: 'ja', href: '/jp' },
    pt: { name: 'Português | Portuguese', display: 'PT', code: 'pt', href: '/pt' },
    ko: { name: '한국어 | Korean', display: 'KR', code: 'ko', href: '/kr' },
    zh: { name: '中文(简体) | Simplified Chinese', display: 'CN', code: 'zh', href: '/cn', separateDomain: true },
};

export const getOldLocaleByNew = (locale: string): string => {
    for (const locale1 in LanguageMap) {
        if (LanguageMap[locale1].display.toLocaleLowerCase() === locale) {
            return LanguageMap[locale1].code;
        }
    }
    return locale;
};

// Create a dictionary for quick lookup of language codes by display name
export const languageCodeMap = Object.values(LanguageMap).reduce(
    (acc, { display, code }) => {
        acc[display.toLowerCase()] = code;
        return acc;
    },
    {} as Record<string, string>,
);

export const getLocale = (lang?: string): string => {
    const defaultLanguage = lang || config.language.default!;
    const currentLocale = Object.values(LanguageMap).find((locale) => {
        if (locale.display.toLowerCase() === defaultLanguage.toLowerCase()) {
            return locale;
        }
    });
    return currentLocale?.code || defaultLanguage;
};

export type LanguageCode = keyof typeof LanguageMap;

export function getSupportedLocales(): string[] {
    return config.language.supported;
}
